import { createStore } from "vuex";
import { login, getUserInfo, logout } from "@/api/user";
import { Session } from "@/utils/storage.js";
import { getMemberInfo } from "@/api/member";
import router from "@/router"; // 引入router实例，用于跳转登录页
export default createStore({
  state: {
    Authorization: Session.get("token"),
    userInfo: Session.get("userInfo") || {
      header: "",
    },
    windowWidth: window.innerWidth,
    scrollTop: document.documentElement.scrollTop,
    memberInfo: "",
  },
  mutations: {
    setAuthorization(state, auth) {
      state.Authorization = auth;
      Session.set("token", auth);
    },
    setUserInfo(state, userInfo) {
      console.log(userInfo, "userInfo", state);
      state.userInfo = userInfo;
      Session.set("userInfo", userInfo);
    },
    setWindowWidth(state, width) {
      state.windowWidth = width;
    },
    setScrollTop(state, scrollTop) {
      state.scrollTop = scrollTop;
    },
    setLogout(state) {
      Session.remove("token");
      Session.remove("userInfo");
      state.Authorization = "";
      state.memberInfo = "";
    },
    setMemberInfo(state, memberInfo) {
      state.memberInfo = memberInfo;
    },
  },
  getters: {
    // 获取用户信息
    getUserInfo(state) {
      return state.userInfo;
    },
    // 获取token
    getToken(state) {
      return state.Authorization;
    },
    // 获取窗口宽度
    getWindowWidth(state) {
      return state.windowWidth;
    },
    // 获取滚动条位置
    getScrollTop(state) {
      return state.scrollTop;
    },
    // 获取会员信息
    getMemberInfo(state) {
      return state.memberInfo;
    },
    // 获取会员类型
    getMemberType(state) {
      if (!state.memberInfo) {
        return "";
      }
      return state.memberInfo.memberType;
    },
  },
  actions: {
    // 登录
    async loginAction({ commit }, data) {
      console.log(data, "sdfsdfsd");
      const res = await login(data);
      if (res.code == 0) {
        this.commit("setAuthorization", res.data.token); // 设置token
        this.dispatch("getUserInfoAction"); // 获取用户信息
        this.dispatch("getMemberInfoAction"); // 获取会员信息
      }
      return res;
    },
    async getUserInfoAction({ commit }) {
      const res = await getUserInfo();
      if (res.code == 0) {
        commit("setUserInfo", res.data);
      }
      return res;
    },
    // 退出登录
    async logoutAction() {
      const res = await logout();
      if (res.code == 0) {
        this.commit("setLogout");
        router.push({ name: "homeUser", query: { type: "login" } });
      }
      return res;
    },
    // 获取会员信息
    async getMemberInfoAction({ commit }) {
      const res = await getMemberInfo();
      if (res.code == 0) {
        commit("setMemberInfo", res.data);
      }
    },
  },
  modules: {},
});
